import { connect, ConnectedProps } from 'react-redux'

import PasswordResetOverlay from 'components/account/PasswordResetOverlay'
import { RootState } from 'redux/store';

const mapStateToProps = (state: RootState) => ({
  email: state.user.details.email
})

const connector = connect(mapStateToProps, null);

export type PasswordResetOverlayContainerProps = ConnectedProps<typeof connector>

export default connector(PasswordResetOverlay)
